module.exports = __webpack_public_path__ + "static/media/Precomp girls groupled.e29cb94a.jpg";